import { useMutation } from "@tanstack/react-query";
import { findContent } from "../../../api/manual-import";
import { logAxiosError } from "../../../logging/logSentryError";
import { AxiosError } from "axios";
import { Errors } from "../../../types/api";

export const getFindContentMutation = () => useMutation({
    mutationFn: findContent,
    onError: (e: AxiosError) => {
        if (e?.response?.status === Errors.InternalServerError) {
            logAxiosError(e);
        }
    }
});